import React from "react";
import FormHeader from "../common/FormHeader";
import "./themePlaceholder.css";

function RAMS() {
  return (
    <div className="form-page">
      <FormHeader />
      <h2>RAMS Form</h2>
      {/* Add RAMS form fields here */}
      <div className="row mt-4 align-items-end">
        <div className="col-12 d-flex justify-content-center">
          <button type="submit" className="btn btn-primary btn-md fw-bold rounded-3 px-4 py-2" style={{background:'#8b1634',border:'none',fontSize:'1.08rem',boxShadow:'0 2px 8px rgba(139,22,52,0.09)'}}>Submit</button>
        </div>
      </div>
    </div>
  );
}

export default RAMS;
